import React, { Component } from "react";
import { findIndex } from "lodash";
import DrawTool from "../DrawTool";
import MaterialsTray from "../MaterialsTray";
import DesignTool from "../../designtool";
import { MAX_WIDTH_SP, CHARM_TYPE, EARRINGS_TYPE_ID } from "../../const";

export default class Content extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.handleGetHeightMain();
  }

  componentDidUpdate(prevProps) {
    let {
      isShowPopupSp,
      getWidthBrowser,
      getHeightBrowser,
      isOrientation
    } = this.props;
    let elm = document.getElementById("main_wrap_sp");
    let elmntWrap = document.getElementById("wrap_draw_tool");

    if (elm) {
      if (isShowPopupSp !== prevProps.isShowPopupSp && isShowPopupSp) {
        if (getWidthBrowser() >= 768) {
          elm.style.height = `320px`;
          elmntWrap.style.height = `320px`;
        } else {
          elm.style.height = `168px`;
          elmntWrap.style.height = `168px`;
        }

        if (480 > getHeightBrowser() && window.orientation !== 0) {
          elm.style.height = `66px`;
          elmntWrap.style.height = `66px`;
        }

        this.handleUpdateDesign();
      }

      if (isShowPopupSp !== prevProps.isShowPopupSp && !isShowPopupSp) {
        if (getWidthBrowser() >= 768) {
          elm.style.height = `${getHeightBrowser() - 314}px`;
          elmntWrap.style.height = `${getHeightBrowser() - 354}px`; // fix positon canvas in mobile
        } else {
          elm.style.height = `${getHeightBrowser() - 259}px`;
          elmntWrap.style.height = `${getHeightBrowser() - 299}px`; // fix positon canvas in mobile
        }

        if (480 > getHeightBrowser() && window.orientation !== 0) {
          elm.style.height = `${getHeightBrowser() - 204}px`;
          elmntWrap.style.height = `${getHeightBrowser() - 234}px`; // fix positon canvas in mobile
        }

        this.handleUpdateDesign();
      }
    }

    if (isOrientation !== prevProps.isOrientation) {
      setTimeout(() => {
        this.handleGetHeightMain();
      }, 100);
    }
  }

  handleGetHeightMain() {
    let { getWidthBrowser, getHeightBrowser } = this.props;
    let elm = document.getElementById("main_wrap_sp");

    if (MAX_WIDTH_SP > getWidthBrowser()) {
      if (getWidthBrowser() >= 768) {
        elm.style.height = `${getHeightBrowser() - 314}px`;
      } else {
        elm.style.height = `${getHeightBrowser() - 259}px`;
      }

      if (480 > getHeightBrowser() && window.orientation !== 0) {
        elm.style.height = `${getHeightBrowser() - 204}px`;
      }
    } else {
      elm.style.height = `${getHeightBrowser() - 136}px`;
    }
  }

  handleUpdateDesign() {
    let {
      getWidthBrowser,
      designInfo,
      productList,
      ringIdActive,
      handleUpdateState
    } = this.props;

    let perimeter = {
      size: designInfo.ringSize,
      sizeMax: designInfo.ringSizeMax,
      sizeMin:designInfo.ringSizeMin,
      color: designInfo.ringColorCode
    };

    if (MAX_WIDTH_SP > getWidthBrowser()) {
      let items = DesignTool.getItems();

      handleUpdateState("isLoadingDrawTool", true);
      if (ringIdActive !== EARRINGS_TYPE_ID) {
        items.sort(function(a, b) {
          return a.angle - b.angle;
        });
      }

      setTimeout(() => {
        DesignTool.changeView(ringIdActive, perimeter);
        for (var i = 0; i < items.length; i++) {
          let index = findIndex(
            productList,
            item => item.id === items[i].productID
          );
          let hookPos = null;

          if (index !== -1 && items[i].productType === CHARM_TYPE) {
            hookPos = {
              hookW: productList[index].charm_hanger_width,
              hookX: productList[index].charm_hanger_coord_x,
              hookY: productList[index].charm_hanger_coord_y
            };
          }

          // update url image
          let n = items[i].imageURL.search(/t=/i);
          let urlImage = "";

          if (n !== -1) {
            urlImage =
              items[i].imageURL.slice(0, n + 2) + `${new Date().getTime()}`;
          } else {
            urlImage = items[i].imageURL + `?t=${new Date().getTime()}`;
          }

          DesignTool.addItem(
            ringIdActive,
            items[i].angle,
            items[i].sizeID,
            urlImage,
            items[i].imageSize,
            items[i].size,
            items[i].productID,
            items[i].productType,
            hookPos,
            items
          );
        }

        handleUpdateState("isLoadingDrawTool", false);
      }, 350);
    }
  }

  render() {
    let { isShowPopupSp, isLoadingDrawTool } = this.props;

    return (
      <main className={`${isShowPopupSp ? "is_show" : ""}`}>
        <div className="container">
          <div
            className={`main_wrap ${isLoadingDrawTool ? "is_loading" : ""}`}
            id="main_wrap_sp"
          >
            <MaterialsTray {...this.props} />
            <DrawTool {...this.props} />
          </div>
        </div>
      </main>
    );
  }
}
